<template>
  <div>
    <!-- LIST START -->
    <template>
      <v-card max-width="300" tile>
        <v-list dense rounded>
          <v-subheader>{{selectedEventText}}</v-subheader>
          <v-list-item-group v-model="selectedListItem" color="orange">
            <v-list-item v-for="(item, i) in items" :key="i" @click="setSelectedEvent(item)">
              <!-- <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon> -->
              <v-list-item-content :color="item.Color">
                <v-row align="center">
                  <v-col cols="2">
                    <v-list-item-icon v-if="item.IsOpen">
                      <v-icon :color="item.Color">mdi-lock-open-variant-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-icon v-else>
                      <v-icon :color="item.Color">mdi-lock-outline</v-icon>
                    </v-list-item-icon>
                  </v-col>
                  <v-col>
                    <v-list-item-title v-text="item.Event"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.EventDescription"></v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </template>
  </div>
</template>
<!-- LIST SLUTT -->

<script>
import axios from "axios";

export default {
  data() {
    return {
      selectedEvent: null,
      selectedEventText: null,
      items: [],
      currentitems:[],
      errors: [],
      regId: Number,
      ac: null,
      selectedListItem: -1,
    };
  },

  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.selectedEventText = "Select...";
    this.getCookies();
    this.getboxesforadmin();
  },

  methods: {
    showAlert(a) {
      alert("Alert! \n" + a);
    },
    setSelectedEvent(event) {
      this.selectedEvent = event;
      this.selectedEventText = event.Event;
      this.$emit("box_changed", event);
    },
    getboxesforadmin() {
      var regId = this.regId;
      var ac = this.ac;
      var eventId = 0;
      var isOpen = -1;
      var toSubmit = { regId, ac, eventId, isOpen };
    //   console.log("toSubmit:", toSubmit);
      var apimethod = "boxesforadmin"; //NB: Remember if (apimethod=="<apimethod>") in setDataArray
      var uri = this.baseUrl + apimethod;
      this.post(uri,toSubmit,apimethod);
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.cookiePilotName = this.$cookies.get("pgbname");
      this.regId = this.cookieRegId;
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    },
    post(uri, toSubmit,apimethod) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.currentitems = response.data;
          this.loading = false;
        //   console.log(this.currentitems);
          this.setDataArray(apimethod);
         }
        )
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setDataArray(apimethod)
    {
        if (apimethod == "boxesforadmin")
        {
            this.items = this.currentitems;
        }

    },
  },
};
</script>
